'use client'

import { HoverCard, HoverCardContent, HoverCardTrigger } from '@sushiswap/ui'
import Link from 'next/link'
import type { ReactNode } from 'react'
import { PathnameButton } from 'src/app/_ui/pathname-button'

const SwapModeButton = ({
  isSupported,
  path,
  children,
}: { isSupported: boolean; path: string; children: ReactNode }) => {
  return isSupported ? (
    <Link href={path}>
      <PathnameButton pathname={path} size="sm">
        {children}
      </PathnameButton>
    </Link>
  ) : (
    <HoverCard>
      <HoverCardTrigger>
        <PathnameButton
          pathname={path}
          size="sm"
          disabled
          className="cursor-not-allowed"
        >
          {children}
        </PathnameButton>
      </HoverCardTrigger>
      <HoverCardContent className="!px-3 !py-1.5 text-xs">
        Not supported on this network
      </HoverCardContent>
    </HoverCard>
  )
}

export const SwapModeButtons = () => {
  return (
    <div className="flex gap-1 md:gap-2 flex-wrap">
      <SwapModeButton isSupported={true} path="/swap">
        Swap
      </SwapModeButton>
    </div>
  )
}
